export default (function() {
    if (typeof window.App !== 'undefined') {
        return window.App;
    }
    return {};
})();